import { DefaultToastOptions } from 'react-hot-toast';

export const toastOptions: DefaultToastOptions = {
  className: 'toast toast-default',
  duration: 5000,
  style: { zIndex: 1000 },
  success: {
    className: 'toast toast-success',
    duration: 3000,
  },
  error: {
    className: 'toast toast-error',
    duration: 7000,
  },
  loading: {
    className: 'toast toast-loading',
    duration: Infinity,
  },
  custom: {
    className: 'toast toast-custom',
  },

};
